import {
  ASIENTO_GRANT_FEATURES,
  ASIENTO_GRANT_LABELS,
  ASIENTO_GRANT_MODULE_IDS,
} from './asientoGrantModules'
import {
  NOMINA_GRANT_FEATURES,
  NOMINA_GRANT_LABELS,
  NOMINA_GRANT_MODULE_IDS,
} from './nominaGrantModules'

/**
 * Module grants: capacidades que se guardan en modulePermissions pero NO son módulos
 * con ruta. Se editan en Permisos de Funciones (no en el árbol de módulos) y su default
 * sin fila es el default por rol (ADMIN/COLABORADOR/SUPER_COLABORADOR).
 *
 * Agregar un grant nuevo = crear su archivo de constantes y sumarlo acá.
 */
export const MODULE_GRANT_MODULE_IDS = [
  ...ASIENTO_GRANT_MODULE_IDS,
  ...NOMINA_GRANT_MODULE_IDS,
]

export const MODULE_GRANT_FEATURES = [
  ...ASIENTO_GRANT_FEATURES,
  ...NOMINA_GRANT_FEATURES,
]

export const MODULE_GRANT_LABELS = {
  ...ASIENTO_GRANT_LABELS,
  ...NOMINA_GRANT_LABELS,
}

export function isModuleGrantModule(moduleId) {
  return MODULE_GRANT_MODULE_IDS.includes(moduleId)
}
